import axios from "axios";

export const exportInvoiceExcel = async (kostenstelle: string, from: string, to: string) => {
  try {
    const token = localStorage.getItem("authToken");
    const response = await axios.get("/api/accounting/export-excel", {
      params: { kostenstelle, from, to },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: "arraybuffer",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `Rechnungsübersicht_${kostenstelle}_${from}_bis_${to}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Fehler beim Exportieren der Excel-Datei:", error);
    alert("Fehler beim Export. Bitte prüfen Sie die Eingaben.");
  }
};
